import { getImagePath } from '@Actions/images.actions';
import { LoadingPage } from '@innovyze/stylovyze';
import { getImagePathsList } from '@Selectors/images.selectors';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as Styled from './ImageLoader.styles';

const ImageLoader = ({ imageKey }: { imageKey: string }) => {
	const dispatch = useDispatch();
	const fullImagePaths = useSelector(getImagePathsList);
	const filteredImagePaths = fullImagePaths.filter(
		image => image.key === imageKey,
	);
	const imagePath = filteredImagePaths.length ? filteredImagePaths[0] : null;

	useEffect(() => {
		if (!imagePath) dispatch(getImagePath(imageKey));
	}, [imagePath]);

	const renderChild = () => {
		if (imagePath) {
			if (imagePath.resolved)
				return <Styled.StyledImage src={imagePath.path} />;
			else
				return (
					<Styled.StyledText variant="heading-large-strong">
						Image is no longer available
					</Styled.StyledText>
				);
		}
		return <LoadingPage />;
	};

	return <Styled.StyledContainer>{renderChild()}</Styled.StyledContainer>;
};

export default ImageLoader;
